"use strict";
// Do not edit directly
// Generated on Fri, 19 May 2023 23:23:24 GMT
exports.__esModule = true;
exports["default"] = {
    colors: {
        app: {
            background: 'rgb(4, 4, 4)',
            backgroundAlt: 'rgb(45, 46, 49)'
        },
        border: {
            "default": 'rgb(223, 224, 225)',
            grey: 'rgb(68, 68, 69)',
            greyStrong: 'rgb(96, 97, 98)',
            primary: 'rgb(120, 187, 250)',
            primarySubdued: 'rgb(0, 68, 145)',
            secondary: 'rgb(135, 114, 229)',
            secondarySubdued: 'rgb(66, 39, 153)',
            critical: 'rgb(255, 116, 95)',
            criticalSubdued: 'rgb(191, 42, 0)',
            warningSubdued: 'rgb(222, 149, 0)',
            successSubdued: 'rgb(0, 81, 50)'
        },
        focus: {
            ringPrimary: 'rgba(2, 101, 220, 0.5)',
            ringCritical: 'rgba(249, 77, 50, 0.5)'
        },
        active: {
            "default": 'rgba(255, 255, 255, 0.2)',
            strong: 'rgba(255, 255, 255, 0.7)',
            primary: 'rgba(2, 101, 220, 0.25)',
            critical: 'rgba(249, 77, 50, 0.25)',
            onGrey: 'rgba(20, 20, 20, 0.16)',
            onPrimary: 'rgba(20, 20, 20, 0.16)',
            onCritical: 'rgba(20, 20, 20, 0.16)'
        },
        hover: {
            "default": 'rgba(255, 255, 255, 0.08)',
            subdued: 'rgba(255, 255, 255, 0.04)',
            primary: 'rgba(2, 101, 220, 0.15)',
            critical: 'rgba(249, 77, 50, 0.15)',
            onGrey: 'rgba(255, 255, 255, 0.08)',
            onPrimary: 'rgba(255, 255, 255, 0.16)',
            onCritical: 'rgba(255, 255, 255, 0.16)'
        },
        status: {
            critical: 'rgb(255, 116, 95)',
            criticalStrong: 'rgb(255, 116, 95)',
            info: 'rgb(120, 187, 250)',
            infoStrong: 'rgb(120, 187, 250)',
            success: 'rgb(73, 204, 147)',
            successStrong: 'rgb(73, 204, 147)',
            warning: 'rgb(255, 201, 2)',
            warningStrong: 'rgb(255, 201, 2)',
            "default": 'rgb(140, 156, 165)'
        },
        surface: {
            "default": 'rgb(20, 20, 20)',
            inverted: 'rgb(250, 250, 250)',
            invertedStrong: 'rgb(255, 255, 255)',
            grey: 'rgb(68, 68, 69)',
            greyStrong: 'rgb(96, 97, 98)',
            greyStronger: 'rgb(188, 188, 189)',
            greySubdued: 'rgb(45, 46, 49)',
            primary: 'rgb(120, 187, 250)',
            primarySubdued: 'rgba(120, 187, 250, 0.2)',
            secondary: 'rgb(135, 114, 229)',
            secondarySubdued: 'rgba(66, 39, 153, 0.8)',
            critical: 'rgb(255, 116, 95)',
            criticalSubdued: 'rgba(255, 116, 95, 0.2)',
            successSubdued: 'rgba(73, 204, 147, 0.2)',
            warningSubdued: 'rgba(255, 226, 120, 0.2)',
            disabled: 'rgb(96, 97, 98)'
        },
        text: {
            "default": 'rgb(255, 255, 255)',
            inverted: 'rgb(20, 20, 20)',
            subdued: 'rgb(148, 149, 150)',
            primary: 'rgb(120, 187, 250)',
            primarySubdued: 'rgb(2, 101, 220)',
            secondary: 'rgb(193, 182, 242)',
            secondarySubdued: 'rgb(105, 84, 192)',
            critical: 'rgb(255, 116, 95)',
            onGrey: 'rgb(245, 245, 245)',
            onGreySubdued: 'rgb(148, 149, 150)',
            onPrimary: 'rgb(20, 20, 20)',
            onSecondary: 'rgb(20, 20, 20)',
            onWarning: 'rgb(20, 20, 20)',
            onCritical: 'rgb(20, 20, 20)'
        }
    }
};
